import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { CenterAlignedCell } from 'components/Table';
import TraroElement from 'types/api/TraroElement';
import { useIsLoggedIn } from 'hooks/useIsLoggedIn';

import DisabledChevronCell from '../components/DisabledChevronCell/DisabledChevronCell';

const useColumns = () => {
  const { t } = useTranslation();
  const isLoggedIn = useIsLoggedIn();

  return useMemo(() => {
    const columnHelper = createColumnHelper<TraroElement>();

    const columns: ColumnDef<TraroElement, any>[] = [];

    columns.push(
      columnHelper.accessor('element_number', {
        cell: CenterAlignedCell,
        header: t('pages.prosforaProject.volumes.number'),
        size: 10,
        meta: {
          headerClassName: 'center',
        },
      }),
      columnHelper.accessor('context0', {
        cell: CenterAlignedCell,
        header: t('pages.prosforaProject.volumes.issuanceYear'),
        size: 50,
        meta: {
          headerClassName: 'center',
        },
      }),
      columnHelper.accessor('element_name', {
        header: t('pages.prosforaProject.volumes.issuanceName'),
        size: 100,
      }),
      columnHelper.accessor('context1', {
        header: t('pages.prosforaProject.volumes.totalVolume'),
        cell: CenterAlignedCell,
        size: 50,
        meta: {
          headerClassName: 'center',
        },
      }),
    );

    if (isLoggedIn) {
      columns.push(
        columnHelper.accessor(() => '-', {
          id: 'last_bid_date',
          header: t('pages.prosforaProject.volumes.lastBidDate'),
          cell: CenterAlignedCell,
          size: 50,
          meta: {
            headerClassName: 'center',
          },
        }),
        columnHelper.accessor(() => '-', {
          id: 'last_bid_price',
          header: t('pages.prosforaProject.volumes.lastBidPrice'),
          cell: CenterAlignedCell,
          size: 50,
          meta: {
            headerClassName: 'center',
          },
        }),
      );
    }

    columns.push(
      columnHelper.accessor('id', {
        header: '',
        size: 100,
        cell: DisabledChevronCell,
      }),
    );

    return columns;
  }, [t]);
};

export default useColumns;
